import React, { ChangeEvent } from 'react';
import { Button, Col, Input, Row } from 'antd';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import { RouteComponentProps, withRouter } from 'react-router';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { CommonLayout } from 'common/components/Layouts/CommonLayout';
import { ELayoutSize } from 'common/const/common.const';
import { ERoutesPrivate } from 'common/models/routesModel';
import { announcementTableConfig, EAnnouncementStatus, IAnnouncementCollectionFilter } from 'entities/Announcement/Announcement.models';
import { StoreSelector } from 'entities/Store/components/Selector/StoreSelector';
import { IStoreModel, selectorStoreAllKeyId } from 'entities/Store/Store.models';
import { AnnouncementStatusSelector } from 'entities/Announcement/components/Selector/AnnouncementStatusSelector';
import { AnnouncementTable } from 'entities/Announcement/components/AnnouncementTable';

type AllProps = RouteComponentProps;

interface IComponentState {
  filter: IAnnouncementCollectionFilter;
}

class AnnouncementTablePageComponent extends React.PureComponent<AllProps, IComponentState> {
  public debounceSearch: any;
  state: IComponentState = {
    filter: {
      pageIndex: 1,
      name: undefined,
      storeId: undefined,
      // Default to the actionable statuses; the user can clear/expand to include Expired.
      statuses: [EAnnouncementStatus.Active, EAnnouncementStatus.Pending],
    },
  };
  constructor(props: AllProps) {
    super(props);
    this.state.filter = { ...this.state.filter, ...queryToObject<IAnnouncementCollectionFilter>(this.state.filter) };
    this.debounceSearch = debounce(this.autocompleteSearch, 300);
  }

  render() {
    const { filter } = this.state;
    const { name, storeId, statuses } = filter;

    return (
      <CommonLayout typeLayout={ELayoutSize.Large} classStyle="mt-10">
        <Row className="mb-10 width-full" justify="space-between" align="middle">
          <Col span={18}>
            <Row justify="space-between" align="middle">
              <Col span={8}>
                <Input.Search
                  placeholder="Search by announcement name"
                  defaultValue={name}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => this.debounceSearch(e.target.value)}
                />
              </Col>
              <Col span={6}>
                <Row className="flex-noWrap" justify="space-between" align="middle">
                  <span className="mr-4">Store</span>
                  <StoreSelector placeholder="Select store" value={storeId} onChange={this.onStoreSelectorChange} />
                </Row>
              </Col>
              <Col span={6}>
                <Row className="flex-noWrap" justify="space-between" align="middle">
                  <span className="mr-4">Status</span>
                  <AnnouncementStatusSelector
                    placeholder="Select status"
                    value={statuses}
                    onChange={this.onChangeAnnouncementStatus}
                  />
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={3} className="pr-0">
            <Link to={ERoutesPrivate.AnnouncementsCreate}>
              <Button block type="primary" title="Create announcement">
                Create New
              </Button>
            </Link>
          </Col>
        </Row>
        <AnnouncementTable config={announcementTableConfig} filter={filter} />
      </CommonLayout>
    );
  }

  setFilter = (partialFilter: Partial<IAnnouncementCollectionFilter>) => {
    const oldFilter = this.state.filter;
    const filter = { ...oldFilter, ...partialFilter, pageIndex: 1 };

    this.props.history.replace({ search: objectToQuery(filter) });
    this.setState({ filter });
  };

  autocompleteSearch = (text: string) => {
    const name = text === '' ? undefined : text;

    this.setFilter({ name });
  };

  onStoreSelectorChange = (item?: IStoreModel) => {
    const isAll = item?.id === selectorStoreAllKeyId;
    const storeId = item && !isAll ? item?.id : undefined;

    this.setFilter({ storeId });
  };

  onChangeAnnouncementStatus = (statuses?: EAnnouncementStatus[]) => {
    this.setFilter({ statuses });
  };
}

export const AnnouncementTablePage = withRouter(AnnouncementTablePageComponent);
